import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { openEnroll } from "@/lib/checkout";

export const StickyEnroll = () => {
  const [past, setPast] = useState(false);
  const [nearCta, setNearCta] = useState(false);

  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    const targets = ["pricing", "apply"]
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setNearCta(true);
        });
      },
      { threshold: 0.05 }
    );
    targets.forEach((t) => io.observe(t));

    return () => {
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
    };
  }, []);

  const visible = past && !nearCta;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-40 md:hidden"
          data-testid="sticky-enroll-bar"
        >
          <button
            data-testid="sticky-enroll-button"
            onClick={() => openEnroll()}
            className="flex w-full items-center justify-between bg-forest px-6 py-4 text-white shadow-2xl shadow-black/40"
          >
            <span className="text-[12px] uppercase tracking-[0.2em]">
              Enroll Now
            </span>
            <span className="font-serif text-base italic">
              $1,500 — first 6 seats
            </span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyEnroll;
